import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ShuffledChoiceType from '../ShuffledChoiceType';

const SingleChoice1Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ShuffledChoiceType choices={question.choices} />
    </>
);

SingleChoice1Type.propTypes = {
    question: PropTypes.object.isRequired,
};


export default SingleChoice1Type;
